import { useEffect } from "react";
import { useEventsTracking } from "./useEventsTracking";
import { useSigninSuccess } from "./useSigninSuccess";
import { useSupport } from "./useSupport";
import { useCustomerManagementStore } from "./store";
import { useAuthUser } from "./useAuthUser";
import { useGoogleAnalytics } from "./useGoogleAnalytics";
import { useMetaAnalytics } from "./useMetaAnalytics";

export const useInit = () => {
  useSupport(true);
  useEventsTracking();
  useSigninSuccess();
  useGoogleAnalytics();
  useMetaAnalytics()

  const {
    customerManagement: { userStatus },
    fetchUser,
    clearUserStatus,
    fetchOnboardingStatus,
  } = useCustomerManagementStore();
  const { isAuthenticated } = useAuthUser();

  useEffect(() => {
    if (isAuthenticated) {
      fetchUser();
      fetchOnboardingStatus();
    }
  }, [fetchUser, isAuthenticated, fetchOnboardingStatus]);

  useEffect(() => {
    if (userStatus === "success") {
      clearUserStatus();
    }
  }, [clearUserStatus, userStatus]);

  return;
};
